import { React } from 'react';

function Trash(props) {
  return (
    <div className="project-content-container" id="trash-project-content-container">
      <div className="project-content-container-section project-overview">
        <h1>Overview</h1>
        <p>This little scrappy device was a homemade electric trash can vehicle built out of “trash”: scrap wood, cardboard, old cordless drills, and  wheelbarrow wheels. Intended to cause ripples in the modern transportation industry and revolutionize how we think of human-machine-augmented locomotion, this vehicle lasted about two days. What more do you expect from using $20 cordless drills as drive motors?</p>
      </div>
    </div>
  );
}

export default Trash;